import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'reactjs-popup/dist/index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import reducer,{ initialState } from './shared/state/reducer';
import { StateProvider  } from './shared/state/StateProviders';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StateProvider initialState={initialState} reducer={reducer}>
     <BrowserRouter> 
    <App />
    </BrowserRouter> 
    </StateProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
